module.exports = __webpack_public_path__ + "img/icon_external_url.dd78cf88.png";